// extracted by mini-css-extract-plugin
module.exports = {"add_file_zone":"dropZone_add_file_zone__3CJJ8","presentation":"dropZone_presentation__3RCA5","bnt_zone":"dropZone_bnt_zone__3m3Xc","dragActive":"dropZone_dragActive__2ykz9"};